'use es6';

import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { SHARE_EMAIL } from '../shareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareScheduledNicknameTextInput = () => {
  const {
    currentDialog,
    nickname,
    setNickname
  } = useControlsContext();
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: currentDialog === SHARE_EMAIL ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailNicknameLabel"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.shareVia.dialog.form.formSection.nicknameLabel"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailNicknameMessage"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UITextInput, {
      autoFocus: true,
      defaultValue: nickname,
      onChange: e => {
        setNickname(getEventValue(e));
      },
      "data-test-id": "email-report-schedule-nickname"
    })
  });
};
export default ShareScheduledNicknameTextInput;